import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "perPatientValue",
    initialState: 1000,
    reducers: {
        set: (state, action) => action.payload,
    },
});
